import { FC } from "react";
import HighlightOffRoundedIcon from "@mui/icons-material/HighlightOffRounded";

interface Props {
  errors: any;
  currentScript: File | null;
  labelName?: string;
  required?: boolean;
  errorFieldName: string;
  isDragActive: boolean;
  getRootProps: any;
  getInputProps: any;
  onFileChange: (file: File | null) => void;
  LABELS: {
    ScriptRequired: string;
    DropFileHere: string;
    DragDropFileHereOrClickHere: string;
    OrClickHere: string;
  };
  testId?:string;
}

const SIMPLFile: FC<Props> = ({
  errors,
  currentScript,
  labelName,
  required = true,
  errorFieldName,
  isDragActive,
  getRootProps,
  getInputProps,
  onFileChange,
  LABELS,
  testId
}) => {
  const hasError = !!errors?.[errorFieldName];

  return (
    <div className="flex flex-col gap-1">
      <label className={`text-sm font-semibold ${hasError ? "text-red-500" : ""}`}>
        {labelName} {required && <span className="text-red-500">*</span>}
      </label>

      <div
        {...getRootProps()}
        className={`border-2 border-dashed rounded-md p-3 cursor-pointer
        ${hasError ? "border-red-500 bg-red-50" : "border-[#1596A1]"}
        ${isDragActive ? "bg-blue-50" : ""}`}
      >
        <input
          {...getInputProps({
            onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
              const file = e.target.files?.[0] ?? null;
              onFileChange(file);
            },
          })}
          data-test-id={testId}
        />

        {currentScript ? (
          <p className="text-sm text-gray-700">{currentScript.name}</p>
        ) : (
          <div className="flex gap-2 text-sm text-gray-600">
            <button
              type="button"
              className="px-3 py-1 border bg-gray-100 rounded"
            >
              Choose file
            </button>
            <span>{LABELS.DragDropFileHereOrClickHere}</span>
          </div>
        )}
      </div>

      {hasError && (
  <span className="text-xs text-red-500 flex items-center gap-1">
    <HighlightOffRoundedIcon fontSize="small" className="shrink-0" />
    {errors[errorFieldName]?.message}
  </span>
)}

    </div>
  );
};

export default SIMPLFile;
